import { FluentIcon } from "@fluentui/react-icons";
import { IOpsGenieIconProps } from "./OpsGenieIcon.types";
import { Paths } from "Shared/Utils";
import React from "react";
import { mergeClasses } from "@fluentui/react-components";
import { observer } from "mobx-react";
import { useOpsGenieIconStyles } from "./OpsGenieIcon.styles";

const OpsGenieIconBase: FluentIcon = ({ className }: IOpsGenieIconProps) => {
    const classNames = useOpsGenieIconStyles();
    const iconClassName = mergeClasses(classNames.root, className);
    const imgPath = Paths.getStaticFullPath("images/icons/opsgenie-copilot-chatbot-icon.svg");
    return <img src={imgPath} className={iconClassName} alt="opsgenie logo" />;
};

export const OpsGenieIcon = observer(OpsGenieIconBase);
